export const TEST_ID = 'batteriesGrid';
